import React from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Error as ErrorIcon } from "@mui/icons-material";

import { groupByCheck } from "../utils/inputProblems";

// What a user must fix before an input file can be processed: each critical
// problem's location and remedy, grouped by kind. The Admin report
// (InputValidationReportDialog) shows everything; this shows only what blocks.
export default function InputProblemsDialog({ open, onClose, fileName, message, findings }) {
  const groups = groupByCheck(findings);
  const count = (findings || []).length;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ErrorIcon sx={{ color: "#EF4444" }} />
        <Box component="span">
          {fileName ? <>“{fileName}” can’t be processed yet</> : "This file can’t be processed yet"}
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="error" sx={{ mb: 2 }}>
          {message ||
            `It has ${count} problem${count === 1 ? "" : "s"} that must be fixed before it can be processed.`}{" "}
          Correct {count === 1 ? "it" : "them"} in your spreadsheet, then upload the file again.
        </Alert>
        {groups.map(({ check, title, items }) => (
          <Box key={check} sx={{ mb: 2 }} data-testid={`problem-group-${check}`}>
            <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
              {title}{" "}
              <Typography component="span" variant="caption" sx={{ color: "text.secondary" }}>
                ({items.length})
              </Typography>
            </Typography>
            {items.map((f, i) => (
              <Box
                key={`${check}-${i}`}
                sx={{
                  py: 0.75,
                  px: 1.25,
                  mb: 0.5,
                  borderLeft: "3px solid #EF4444",
                  backgroundColor: "#FEF2F2",
                  borderRadius: "0 4px 4px 0",
                }}
              >
                {f.subject && (
                  <Typography
                    variant="caption"
                    component="div"
                    sx={{ fontFamily: "monospace", color: "#991B1B", fontWeight: 600 }}
                  >
                    {f.subject}
                  </Typography>
                )}
                <Typography variant="body2" sx={{ color: "#1F2937" }}>
                  {f.message}
                </Typography>
              </Box>
            ))}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
